import React from 'react';
import { Navigate } from 'react-router-dom';

/**
 * استفاده:
 * <PrivateRoute> ... </PrivateRoute>
 * <PrivateRoute requiredRole="Admin"> ... </PrivateRoute>
 * <PrivateRoute requiredRole="Teacher"> ... </PrivateRoute>
 */
export default function PrivateRoute({ children, requiredRole }) {
  const token = localStorage.getItem('teacherToken');
  const role = localStorage.getItem('teacherRole'); // "Admin" یا "Teacher"

  // اگر توکن نیست → به صفحه ورود
  if (!token) return <Navigate to="/login" replace />;

  // اگر نقش مورد نیاز تعیین شده و با نقش ذخیره‌شده هماهنگ نیست → به داشبورد
  if (requiredRole && role !== requiredRole) {
    return <Navigate to="/dashboard" replace />;
  }

  return children;
}
